module.exports = {
  billboardsData: () => {
    return{
      "IONIQ 5 EV-POWER": {
        "exterior": [
          {
            "title":'Rines',
            "text": "Una disposición paramétrica de píxeles, la cual nos ubica en lo más alto del valor aerodinámico que exige un EV galardonado mundialmente. Disfruta los intrigantes rines del IONIQ 5, pensados para jamás pasar desapercibidos.",
            "image": require("./../assets/IONIQ5/EXTERIOR/Rines.webp"),
            "position": {
              x: 0.952,
              y: 0.370,
              z: 1.485
            }
          },
          {
            "title":"Detalles aerodinámicos",
            "text": "Desde las manijas escondidas en las puertas, pasando por los cortes geométricos de 45° en la carrocería, hasta el alerón Trasero Aerodinámico; el IONIQ 5 presenta un diseño pensado para el alto desempeño de velocidad que exige una movilidad sostenible; una movilidad fluida que no se detiene ante ninguna forma de circulación del aire, solo corre a través de él.",
            "image": require("./../assets/IONIQ5/EXTERIOR/Detalles-Aerodinamicos.webp"),
            "position": {
              x: 0.013,
              y: 1.583,
              z: -1.385
            }

          },
          {
            "title":"Farolas delanteras",
            "text": "Un diseño que trasciende todas las eras y generaciones; el IONIQ 5 nos presenta sus farolas delanteras en forma de píxel que complementan una frontal paramétrica, la cual nos ubica en el minimalismo funcional y de alto valor estético futurista.",
            "image": require("./../assets/IONIQ5/EXTERIOR/Farolas-delanteras.webp"),
            "position": {
              x: 0.650,
              y: 0.762,
              z: 2.198
            }
          },
          {
            "title":"Spoiler trasero aerodinámico",
            "text": "",
            "image": require("./../assets/IONIQ5/EXTERIOR/Espoiler-trasero.webp"),
            "position": {
              x: 0.650,
              y: 0.762,
              z: 2.198
            }
          },
          {
            "title":"Luces traseras",
            "text": "Una infinita creatividad que alimenta una estética futurista, con su iluminación LED en composición de cuadros, los cuales geométricamente nos evocan un diseño altamente tecnológico que no necesariamente nos ubica en la complejidad; presume de las farolas traseras multifuncionales del IONIQ 5, las cuales potencian un corte deportivo e imponente.",
            "image": require("./../assets/IONIQ5/EXTERIOR/Luces-traseras.webp"),
            "position": {
              x: 0.025,
              y: 1.440,
              z: -1.809
            }
          },
          {
            "title":"Sensor de lluvia",
            "text": "La manifestación explícita de la innovación en movimiento, una sincronización automática entre las plumillas del sistema limpiaparabrisas junto con la velocidad general del vehículo en circulación, logrando así una sinergia que permite una concentración ideal en el camino.",
            "image": require("./../assets/IONIQ5/EXTERIOR/Sensor-lluvia.webp"),
            "position": {
              x: 0.025,
              y: 1.510,
              z: 0.586
            }
          },
          {
            "title":"Cargador portátil",
            "text": "Carga tu vehículo eléctrico en cualquier lugar donde haya una toma de corriente disponible: En tu casa, en trabajo, en un centro comercial o incluso en carretera sí necesitas una recarga de emergencia. No tendrás que depender exclusivamente de estaciones de carga públicas, esto es especialmente útil si viajas con frecuencia y puedes llevar el cargador contigo y cargar tu vehículo en cualquier lugar donde puedas conectarte a una toma de corriente estándar y obtener la carga suficiente hasta llegar a una estación de carga pública (carga rápida). Al tener tu propio cargador portátil evitas tener que hacer fila en las estaciones de carga públicas o depender de horarios de carga de otros. Esto te ahorra tiempo y te permite ser más flexible en tus actividades diarias.",
            "image": require("./../assets/IONIQ5/EXTERIOR/Cargador-Portatil.webp"),
            "position": {
              x: 0.025,
              y: 1.110,
              z: 1.744
            }
          },
          {
            "title":"Frenada regenerativa",
            "text": "La frenada regenerativa permite aprovechar la energía cinética generada durante la desaceleración o el frenado del vehículo. En lugar de desperdiciar esta energía en forma de calor, la tecnología de frenada regenerativa la convierte en energía eléctrica, que se almacena en la batería del vehículo para su posterior uso. Esto significa que se recupera parte de la energía que normalmente se perdería en un vehículo de combustión interna, lo que mejora la eficiencia global del vehículo eléctrico. Al recuperar energía durante la frenada, la frenada regenerativa puede aumentar la autonomía de un vehículo eléctrico. Al almacenar la energía generada durante la desaceleración, se reduce la carga de la batería y se puede utilizar para alimentar el vehículo en momentos posteriores, lo que ayuda a extender la distancia recorrida sin necesidad de recargar la batería externamente.",
            "image": require("./../assets/IONIQ5/EXTERIOR/Frenada-Regenerativa.webp"),
            "position": {
              x: 0.962,
              y: 0.616,
              z: 1.254
            }
          },
          {
            "title":"FCA (Asistente de colisión frontal)",
            "text": "Este EV cuenta con un asistente de colisión frontal, el cual verifica que en la inmediatez frontal del vehículo cuando está circulando, no exista ningún peligro inminente: llegando a predecir los posibles cambios de velocidad y trayectoria de los diferentes elementos ubicados al frente en el camino, e incluso asistiendo en la frenada y cambios de dirección leves para alertar al conductor.",
            "image": require("./../assets/IONIQ5/EXTERIOR/FCA.webp"),
            "position": {
              x: -0.074,
              y: 0.742,
              z: 2.315
            }
          },
          {
            "title":"SCC (Control de crucero inteligente) + Stop&Go",
            "text": "El sistema SmartSense, dispone de una proyección de navegación basada en el comportamiento de aceleración y frenada del trayecto; dicha proyección establece una velocidad constante, la cual permite el ahorro de energía desde la batería sin perder desempeño en la seguridad activa del vehículo.",
            "image": require("./../assets/IONIQ5/EXTERIOR/SCC.webp"),
            "position": {
              x: 0,
              y: 1.3,
              z: 1.007
            }
          },
          {
            "title":"LFA (Asistente de seguimiento de carril)",
            "text": "El sistema de Asistencia de Mantenimiento de Carril, permite que la conducción sea completamente eficiente a la hora de trazar el trayecto, disponiendo los sensores externos del vehículo para guiarse en las líneas de guía del camino y así mantener un desplazamiento seguro para los ocupantes y los participantes externos a partir de 60km/h.",
            "image": require("./../assets/IONIQ5/EXTERIOR/LFA.webp"),
            "position": {
              x: -0.768,
              y: 1.184,
              z: 1.007
            }
          },
          {
            "title":"LKA (Asistente de mantenimiento de carril)",
            "text": "Junto con el sistema AMC, este Asistente de Seguimiento de Carril provee al vehículo de un tránsito equilibrado entre la eficiencia de las maniobras y la emoción del avance, esto debido a que puede mantener centrado en los carriles al EV a una velocidad constante entre los 0 y 180 km/h en ciudad y carretera con sus singulares caminos.",
            "image": require("./../assets/IONIQ5/EXTERIOR/LKA.webp"),
            "position": {
              x: 0.787,
              y: 1.184,
              z: 1.007
            }
          },
          {
            "title":"BCA (Asistente de colisión de punto ciego)",
            "text": "Este sistema que provee un respaldo de seguridad superior, el Asistente de Colisión de Punto Ciego dispone de sensores ubicados estratégicamente en el exterior del EV, los cuales se activan en los ya comprobados espacios sin visibilidad a la hora de hacer cambios de carriles en la conducción; accionando un protocolo jerarquizado de alerta sonora y visual, seguido de la modificación de la trayectoria en el volante y por último un freno de emergencia efectivo.",
            "image": require("./../assets/IONIQ5/EXTERIOR/BCA.webp"),
            "position": {
              x: 0.739,
              y: 0.967,
              z: -2.108
            }
          },
          {
            "title":"PDW (Sensores de parqueo delanteros y traseros)",
            "text": "Un vehículo eléctrico que incorpora toda la tecnología al servicio de la seguridad, con sus sensores multifuncionales externos los cuales detectan cualquier tipo de obstáculo a la hora de parquear el vehículo, adelantándose a los posibles escenarios que pongan en riesgo la seguridad e integridad de los actores internos y externos en la conducción.",
            "image": require("./../assets/IONIQ5/EXTERIOR/PDW.webp"),
            "position": {
              x: 0,
              y: 0.645,
              z: -2.108
            }
          },
          {
            "title":"Techo panorámico",
            "text": "Cuenta con una cortina deslizable eléctrica que permite visualizar o bloquear el paisaje a través de su techo de cristal “visión roof”, el cual permite mejorar la experiencia de viaje en el día o en la noche, buscando una armonía con la naturaleza y renovando nuestro compromiso por la sostenibilidad de todos.",
            "image": require("./../assets/IONIQ5/INTERIOR/Techo-Panoramico.webp"),
            "position": {
              x: 0,
              y: 1.65,
              z: -0.002
            }
          },
        ],
        "interior": [
          {
            "title":"Cojinería con cuero",
            "text": "",
            "image": require("./../assets/IONIQ5/INTERIOR/Cojineria.webp"),
            "position": {
              x: 0,
              y: 1,
              z: -0.891
            }
          },
          {
            "title":"Tablero de instrumentos",
            "text": "",
            "image": require("./../assets/IONIQ5/INTERIOR/Tablero-instrumentos.webp"),
            "position": {
              x: 0,
              y: 1.090,
              z: 0.599
            }

          },
          {
            "title":"Materiales amigables con el medio ambiente",
            "text": "En la disposición del habitáculo principal interno, se encuentran los resultados de diferentes técnicas innovadoras en la recuperación de materiales orgánicos (Papel, Cuero Eco-Procesado, Pintura Bio, Plástico Reciclado, entre otros) los cuales han sido adaptados a la fabricación de elementos que componen el espacio interno; logrando así el máximo aporte posible al ambiente, desde cada elemento de este EV.",
            "image": require("./../assets/IONIQ5/INTERIOR/Materiales.webp"),
            "position": {
              x: -0.391,
              y: 0.987,
              z: -0.106
            }
          },
          {
            "title":"Techo panorámico",
            "text": "Cuenta con una cortina deslizable eléctrica que permite visualizar o bloquear el paisaje a través de su techo de cristal “visión roof”, el cual permite mejorar la experiencia de viaje en el día o en la noche, buscando una armonía con la naturaleza y renovando nuestro compromiso por la sostenibilidad de todos.",
            "image": require("./../assets/IONIQ5/INTERIOR/Techo-Panoramico.webp"),
            "position": {
              x: 0,
              y: 1.427,
              z: -0.002
            }
          },
          {
            "title":"Aire acondicionado",
            "text": "En la parte delantera, el acompañante puede escoger la temperatura ideal para asistir el viaje, al igual que el conductor el cual es asistido completamente por el sistema de Aire Acondicionado Automático; este se encargará de su temperatura y la de su copiloto de forma independiente, maximizando la comodidad de todo el vehículo.",
            "image": require("./../assets/IONIQ5/INTERIOR/Aire-acondicionado.webp"),
            "position": {
              x: -0.465,
              y: 1.018,
              z: 0.576
            }
          },
          {
            "title":"Piso delantero plano",
            "text": "Dentro de las decisiones inteligentes del vehículo, se ubica la batería general debajo del habitáculo principal, eliminando el túnel central que corta la fluidez del piso interno de la parte delantera; logrando así una conexión natural entre el conductor y su compañero del camino.",
            "image": require("./../assets/IONIQ5/INTERIOR/Piso-delantero-plano.webp"),
            "position": {
              x: -0.465,
              y: 0.520,
              z: 0.611
            }
          },
          {
            "title":"Conectores USB y 12v convencional",
            "text": "Se disponen de 7 conectores independientes, estratégicamente ubicados para maximizar la comodidad de todos los pasajeros y así minimizar el sacrificio de convivencia entre todos. Se ubican 2 “USB Chargers” en la parte frontal, junto con 1 “Data Support” y 1 “Outlet Power” en la parte intermedia delantera; atrás se ubican 2 “USB Chargers” de 110 v y 220 v con función opcional de invertir, al final en el portaequipaje, se encuentra 1 “Outlet Power” independiente.",
            "image": require("./../assets/IONIQ5/INTERIOR/Conectores-USB.webp"),
            "position": {
              x: 0.009,
              y: 0.827,
              z: -0.366
            }
          },
          {
            "title":"Cargador inalámbrico de celular",
            "text": "Una función de carga conveniente y rápida, desde el motor hasta los dispositivos del conductor, el IONIQ 5 presenta una estación de carga inalámbrica para smartphones compatibles con esta tecnología que se activa una vez estén cerradas todas las puertas del vehículo.",
            "image": require("./../assets/IONIQ5/INTERIOR/Cargador-inalambrico.webp"),
            "position": {
              x: 0.009,
              y: 0.675,
              z: 0.252
            }
          }
        ]
      },

      "TUCSON HEV LIMITED": {
        "exterior": [
          {
            "title":"Rendimiento del motor",
            "text": "La TUCSON Híbrida combina un motor 1.6L Turbo y uno eléctrico sin recarga externa, optimizando consumo y emisiones.",
            "image": require("./../assets/TUCSON/EXTERIOR/tucson-hev-hyundai-caracteristicas-rendimiento-motor.webp"),
            "position": {
              x: 0.0,
              y: 1.148,
              z: 1.748
            }
          },
          {
            "title":"Insonorización mejorada",
            "text": "La TUCSON Híbrida ofrece confort acústico con diseño avanzado y materiales que reducen ruido y vibración.",
            "image": require("./../assets/TUCSON/EXTERIOR/tucson-hev-hyundai-caracteristicas-rendimiento-insonorizacion-mejorada.webp"),
            "position": {
              x: 0.000,
              y: 0.866,
              z: 2.357
            }
          },
          {
            "title":"Sistema de luces LED",
            "text": "La TUCSON Híbrida cuenta con faros delanteros, señal de giro, luz baja, de carretera y luces traseras combinadas, todas LED, que armonizan con su diseño frontal para ofrecer una imagen moderna e impactante.",
            "image": require("./../assets/TUCSON/EXTERIOR/tucson-hev-hyundai-caracteristicas-sistema-de-luces-led.webp"),
            "position": {
              x: 0.770,
              y: 0.886,
              z: 2.123
            }
          },
          {
            "title":"Rines",
            "text": "La TUCSON Híbrida incluye rines de aleación bitono de 18” en la versión Premium AT 4x2 y de 19” en las versiones Limited AT 4x2 y Limited AT 4x4, combinando estilo y rendimiento en cada modelo.",
            "image": require("./../assets/TUCSON/EXTERIOR/tucson-hev-hyundai-caracteristicas-Apertura-electrica-del-baul.webp"),
            "position": {
              x: 0.988,
              y: 0.271,
              z: 1.367
            }
          },
          {
            "title":"Apertura eléctrica del baúl",
            "text": "La apertura y cierre eléctrico ajustable desde el sistema AVNT es ideal para conductores de menor estatura que requieran personalizar la altura.",
            "image": require("./../assets/TUCSON/EXTERIOR/tucson-hev-hyundai-caracteristicas-Apertura-electrica-del-baul.webp"),
            "position": {
              x: 0.427,
              y: 1.093,
              z: -2.362
            }
          },
          {
            "title":"Rieles portaequipaje y SunRoof dual",
            "text": "Perfecta para viajes largos o escapadas de fin de semana, con un riel portaequipaje tipo puente que facilita llevar carga adicional. Además, disfruta de vistas panorámicas con su SunRoof dual.",
            "image": require("./../assets/TUCSON/EXTERIOR/tucson_hev_hyundai_tecnologia_rieles_portaequipaje_sunroof_dual_d74136a315.webp"),
            "position": {
              x: 0.000,
              y: 1.725,
              z: -0.207
            }
          },
          {
            "title":"Sensores de parqueo",
            "text": "Los sensores te ayudan a estacionar de forma segura, emitiendo advertencias ante peatones u obstáculos cercanos.",
            "image": require("./../assets/TUCSON/EXTERIOR/tucson_hev_hyundai_tecnologia_sensores_de_parqueo_7c7abbd4a0.webp"),
            "position": {
              x: 0.000,
              y: 0.416,
              z: -2.403
            }
          },
          {
            "title":"Sistema de frenado mejorado",
            "text": "Con un pedal optimizado y una capacidad de respuesta mejorada, el sistema de frenado garantiza un alto rendimiento.",
            "image": require("./../assets/TUCSON/EXTERIOR/tucson_hev_hyundai_tecnologia_sistema_de_frenado_mejorado_c140cb608c.webp"),
            "position": {
              x: 0.988,
              y: 0.635,
              z: 1.407
            }
          },
          {
            "title":"Asistente de luces altas",
            "text": "Ajusta las luces según el tráfico y las condiciones de iluminación.",
            "image": require("./../assets/TUCSON/EXTERIOR/tucson_hev_hyundai_tecnologia_asistente_de_luces_altas_5b8354cbe7.webp"),
            "position": {
              x: 0.748,
              y: 0.600,
              z: 2.157
            }
          },
          {
            "title":"BCA",
            "text": "Asistete de colisión de punto ciego.",
            "image": require("./../assets/TUCSON/EXTERIOR/tucson_hev_hyundai_smart_semse_bca_32b3ef7182.webp"),
            "position": {
              x: 0.947,
              y: 0.950,
              z: -1.869
            }
          },
          {
            "title":"LKA",
            "text": "Asistente de mantenimiento de carril.",
            "image": require("./../assets/TUCSON/EXTERIOR/tucson_hev_hyundai_smart_semse_lka_0d2c676171.webp"),
            "position": {
              x: -0.287,
              y: 1.612,
              z: 0.363
            }
          },
          {
            "title":"FCA",
            "text": "Asistencia de colisión frontal.",
            "image": require("./../assets/TUCSON/EXTERIOR/tucson_hev_hyundai_smart_semse_fca_eefa731c30.webp"),
            "position": {
              x: 0.287,
              y: 1.612,
              z: 0.363
            }
          },
          {
            "title":"HTRAC",
            "text": "Sistema de tracción en las cuatro ruedas.",
            "image": require("./../assets/TUCSON/EXTERIOR/tucson_hev_hyundai_smart_semse_htrac_26ca268e8c.webp"),
            "position": {
              x: 0.996,
              y: 0.178,
              z: -1.291
            }
          },
        ],
        "interior": [
          {
            "title":"Tablero de instrumentos de 12.3” y Centro de entretenimiento",
            "text": "Rediseñado con pantallas avanzadas, su LCD panorámico de alta resolución ofrece información clara y una interfaz intuitiva para una interacción fluida con tecnología de última generación.",
            "image": require("./../assets/TUCSON/INTERIOR/tucson_hev_hyundai_caracteristicas_Interior_tablero_de_instrumentos_y_centro_de_entretenimiento_30a4be0176.webp"),
            "position": {
              x: 0.001,
              y: 1.078,
              z: 0.627
            }
          },
          {
            "title":"Aire acondicionado automático dual",
            "text": "Controla el clima del vehículo de forma independiente con su pantalla táctil de 6.6 pulgadas, brindando una experiencia tecnológica avanzada.",
            "image": require("./../assets/TUCSON/INTERIOR/tucson-hev-hyundai-caracteristicas-Interior-aire-acondicionado-automatico-dual.webp"),
            "position": {
              x: -0.061,
              y: 0.914,
              z: 0.577
            }
          },
          {
            "title":"Cojinería en cuero",
            "text": "Los asientos en cuero brindan una experiencia de lujo y confort en cada viaje.",
            "image": require("./../assets/TUCSON/INTERIOR/tucson-hev-hyundai-caracteristicas-cojineria-en-cuero.webp"),
            "position": {
              x: -0.366,
              y: 0.778,
              z: 0.122
            }
          },
          {
            "title":"Cargador inalámbrico para celular",
            "text": "Carga tu smartphone de forma rápida y sin cables. Además, el vehículo te avisará si sales sin el teléfono.",
            "image": require("./../assets/TUCSON/INTERIOR/tucson-hev-hyundai-caracteristicas-cargador-inalambrico-para-celular.webp"),
            "position": {
              x: 0.0,
              y: 0.822,
              z: 0.589
            }
          },
          {
            "title":"6 Airbags",
            "text": "La TUCSON Híbrida está equipada con 6 airbags y pretensores de cinturones de seguridad que mejoran la sujeción de los pasajeros en caso de colisión.",
            "image": require("./../assets/TUCSON/INTERIOR/tucson_hev_hyundai_tecnologia_airbags_9f46f5f3ba.webp"),
            "position": {
              x: -0.425,
              y: 1.092,
              z: 0.618
            }
          },
          {
            "title":"SCC",
            "text": "Control Crucero Inteligente.",
            "image": require("./../assets/TUCSON/INTERIOR/tucson_hev_hyundai_smart_semse_scc_e959f19c93.webp"),
            "position": {
              x: 0.000,
              y: 1.199,
              z: 0.847
            }
          },
        ]
      },

      "PALISADE SPORT": {
        "exterior": [
          {
            "title":"LUCES TRASERAS",
            "text": "Las luces traseras de este vehículo, ofrecen iluminación de última generación, así logrando proveer mayor seguridad para ti y los que vienen siguiendo tus pasos; esto con el apoyo adicional de unas luminarias auxiliares ubicadas en el bómper trasero, para una eficiente ejecución premium.",
            "image": require("./../assets/PALISADE/EXTERIORS/trasera.webp"),
            "position": {
              x: 0.729,
              y: 1.127,
              z: -2.369
            }
          },
          {
            "title":"LUCES DELANTERAS",
            "text": "La Hyundai PALISADE, presenta una construcción dinámica de farolas delanteras, las cuales complementan el agresivo frontal de la camioneta; proporcionando 8 posibilidades dinámicas de comportamiento, para iluminar el destino.",
            "image": require("./../assets/PALISADE/EXTERIORS/frontal.webp"),
            "position": {
              x: 0.711,
              y: 0.998,
              z: 2.294
            }
          },
          {
            "title":"RINES",
            "text": "Desde sus rines, la PALISADE presenta diferentes innovaciones en su imagen, con su diseño en bitono de 20”, disponibles para el gusto de cada conductor; admira sus geometrías s encillas pero únicas, que siempre estarán a la vanguardia.",
            "image": require("./../assets/PALISADE/EXTERIORS/Rines.webp"),
            "position": {
              x: 1.03,
              y: 0.413,
              z: 1.525
            }
          },
          {
            "title":"IMPONENCIA QUE EMOCIONA E INSPIRA.",
            "text": "Un diseño exterior que fue pensado para eliminar todas las debilidades del camino, aquellas que frenan la admiración y deseo por nuestro vehículo; disfruta de una estética que jamás pasará desapercibida.",
            "image": require("./../assets/PALISADE/EXTERIORS/exterior-disenio.webp"),
            "position": {
              x: 0,
              y: 1.53,
              z: 0.883
            }
          },
          {
            "title":"BÓMPER TRASERO",
            "text": "La PALISADE acopla un diseño que refleja fuerza y estabilidad en su bómper trasero, el cual se sumerge y acompaña al corte general estético de la SUV; un diseño propio del concepto premium nativo de esta camioneta.",
            "image": require("./../assets/PALISADE/EXTERIORS/bomper-trasero.webp"),
            "position": {
              x: 0,
              y: 0.476,
              z: -2.514
            }
          },
          {
            "title":"PARRILLA DELANTERA",
            "text": "Nuevamente, un vehículo que refleja toda la esencia de nuestra motivación, la fuerza que abre los caminos; presentamos en esta SUV una parrilla frontal con un diseño geométrico extendido de lado a lado, para un mayor cubrimiento del camino.",
            "image": require("./../assets/PALISADE/EXTERIORS/parrilla-delantera.webp"),
            "position": {
              x: 0,
              y: 0.684,
              z: 2.566
            }
          },
          {
            "title":"TECHO PANORÁMICO",
            "text": "En Hyundai, expandimos tus posibilidades de admirar el camino, así que te ofrecemos un techo panorámico de cristal, el cual se acciona eléctricamente para abrir y cerrar; experimenta una visión premium, recibiendo más luz del ambiente y sintiendo mayor libertad.",
            "image": require("./../assets/PALISADE/EXTERIORS/techo-panoramico.webp"),
            "position": {
              x: 0,
              y: 1.817,
              z: 0.021
            }
          },
          {
            "title":"HTRAC – TRACCIÓN EN TODAS LAS RUEDAS",
            "text": "Con esta conveniente tecnología, disfruta de una tracción enfocada en cada una de las llantas de la PALISADE, lo cual se calibra su intensidad de acuerdo al modo de manejo escogido; logrando así estar preparada para cualquier terreno y sus adversidades al suelo.",
            "image": require("./../assets/PALISADE/EXTERIORS/htrac.webp"),
            "position": {
              x: 1.033,
              y: 0.449,
              z: -0.056
            }
          },
          {
            "title":"FCA – ASISTENTE DE COLISIÓN FRONTAL",
            "text": "Con el Asistente de Colisión Frontal, siente el respaldo de tu vehículo para tomar las medidas necesarias en pro de la seguridad de Ciclistas, Peatones y Vehículos en Intersecciones; todos ellos posiblemente querrán estar muy cerca de la SUV premium de Hyundai.",
            "image": require("./../assets/PALISADE/EXTERIORS/FCA.webp"),
            "position": {
              x: 0,
              y: 1.039,
              z: 2.461
            }
          },
          {
            "title":"HBA ASISTENCIA DE LUCES DE CARRETERA",
            "text": "En caminos de doble vía, el Asistente de Luces de Carretera te ayudará a alertar oportunamente a los conductores que transitan contrariamente en el otro carril (con un encendido y apagado automático de las propias farolas del sistema), lo cual significa maximizar las probabilidades de llegar correctamente a tu destino.",
            "image": require("./../assets/PALISADE/EXTERIORS/hba.webp"),
            "position": {
              x: 0.836,
              y: 0.759,
              z: 2.301
            }
          },
        ],
        "interior": [
          {
            "title":"CENTRO DE ENTRETENIMIENTO",
            "text": "Disfruta de una pantalla digital multimedia de 12.3” exclusiva para ti, con conexión a Apple Carplay y Android Auto, donde lograrás percibir, de manera sencilla, intuitiva, lógica y amigable, toda la información que tiene el vehículo para ti.",
            "image": require("./../assets/PALISADE/INTERIORS/centro-entretenimiento.webp"),
            "position": {
              x: 0,
              y: 1.202,
              z: 0.779
            }
          },
          {
            "title":"AIRE ACONDICIONADO DELANTERO AUTOMATIC BI-ZONA",
            "text": "En el habitáculo delantero, encontrarás una disposición de Aire Automático que te permite calibrar independientemente la temperatura para cada ocupante (piloto y copiloto), logrando así una comodidad independiente junto a una experiencia confortante en conjunto.",
            "image": require("./../assets/PALISADE/INTERIORS/Aire-acondicionado.webp"),
            "position": {
              x: 0.046,
              y: 0.961,
              z: 0.724
            }
          },
          {
            "title":"VENTILACIÓN Y CALEFACCIÓN EN SILLA DE CONDUCTOR",
            "text": "Experimenta la definición de confort premium con el asiento versátil para el conductor, el cual te provee ventilación y calefacción ajustable a tu gusto; logrando sumergirse en la verdadera comodidad desde tu interior.",
            "image": require("./../assets/PALISADE/INTERIORS/calefaccion.webp"),
            "position": {
              x: 0.416,
              y: 0.845,
              z: 0.376
            }
          },
          {
            "title":"CARGADOR INALÁMBRICO DE CELULAR",
            "text": "Disfruta de la disposición de un conveniente cargador inalámbrico para celulares móviles (smarthphones) presente en la PALISADE, en donde no necesitas cable para ningún tipo de dispositivo, además de la tranquilidad de una alerta de carga completa.",
            "image": require("./../assets/PALISADE/INTERIORS/Cargador-inalambrico.webp"),
            "position": {
              x: 0,
              y: 0.883,
              z: 0.455
            }
          },
          {
            "title":"CAPACIDAD 8 PASAJEROS",
            "text": "En la Hyundai PALISADE, dispones de 8 asientos (incluido conductor) para maximizar su utilidad y así mismo la felicidad de tus cercanos; cada uno de ellos dotado con diferentes características, que juntas crean el confort de una SUV de lujo.",
            "image": require("./../assets/PALISADE/INTERIORS/capacidad.webp"),
            "position": {
              x: 0,
              y: 0.995,
              z: 0.035
            }
          },
          {
            "title":"LEVAS EN EL VOLANTE – CAMBIO DE MARCHAS",
            "text": "Una decisión inteligente de diseño desde el equipo Hyundai, las levas en el volante para el cambio de marchas, te permiten una mayor concentración en el camino, al igual que te exigen un mayor dominio del contacto con el manubrio; una característica digna de los nuevos grandes conductores.",
            "image": require("./../assets/PALISADE/INTERIORS/levas-volante.webp"),
            "position": {
              x: 0.416,
              y: 1.152,
              z: 0.53
            }
          },
          {
            "title":"ESPEJO OSCURECIMIENTO PROGRESIVO",
            "text": "Con el espejo retrovisor electro-cromático de oscurecimiento progresivo, podrás tranquilizarte por la posibilidad de ver correctamente a aquellos que vienen inspirándose en tu camino; un espejo que se ajusta al nivel necesario de contraste para la luz que recibe de la parte trasera.",
            "image": require("./../assets/PALISADE/INTERIORS/espejo.webp"),
            "position": {
              x: 0,
              y: 1.489,
              z: 0.518
            }
          },
          {
            "title":"SELECTOR MULTI–TERRENO",
            "text": "En la Hyundai PALISADE, experimentarás un reto digno de conductores premium, el cual significa calibrar a tu gusto el poder de conducción, la energía de torque, la tenacidad de los frenos y otros factores necesarios para cada tipo de terreno con diferentes modos de manejo: Snow (Nieve), Mud (Lodo), Sand (Arena), todos estos factores agrupados y ajustados inteligentemente a tu conveniencia.",
            "image": require("./../assets/PALISADE/INTERIORS/multi-terreno.webp"),
            "position": {
              x: -0.06,
              y: 0.915,
              z: 0.631
            }
          },
          {
            "title":"PDW - SENSORES DE PARQUEO",
            "text": "Con la Hyundai PALISADE, el trayecto es seguro desde el principio hasta el final, donde necesitas aclarar todos tus puntos de visión; por esto te ofrecemos el sistema de Sensores de Parqueo con 3 rangos de alcance a velocidad baja, cubriendo 6 frentes simultáneamente, alertando ante cualquier posible peligro en su alcance.",
            "image": require("./../assets/PALISADE/INTERIORS/pdw.webp"),
            "position": {
              x: -0.143,
              y: 1.195,
              z: 0.785
            }
          },
          {
            "title":"LKA – ASISTENTE DE MANTENIMIENTO DE CARRIL",
            "text": "Tu PALISADE, te ayudará a mantenerte seguro en tu carril y mantener seguros a tus colegas del camino, con su Asistente de Mantenimiento de Carril siente el respaldo de alertas tempranas a posibles desvíos leves y bruscos sobre tu línea de trayecto.",
            "image": require("./../assets/PALISADE/INTERIORS/lka.webp"),
            "position": {
              x: 0.399,
              y: 1.303,
              z: 0.627
            }
          },
          {
            "title":"SSC – CONTROL CRUCERO INTELIGENTE + STOP Y GO",
            "text": "Con la Hyundai PALISADE, el trayecto es seguro desde el principio hasta el final, donde necesitas aclarar todos tus puntos de visión; por esto te ofrecemos el sistema de Sensores de Parqueo con 3 rangos de alcance a velocidad baja, cubriendo 6 frentes simultáneamente, alertando ante cualquier posible peligro en su alcance.",
            "image": require("./../assets/PALISADE/INTERIORS/ssc.webp"),
            "position": {
              x: 0.178,
              y: 1.066,
              z: 0.725
            }
          },
        ]
      },

      "STARIA LUJO": {
        "exterior": [
          {
            "title":"SUSPENSIÓN DELANTERA: MACPHEARSON",
            "text": "Aplica para versiones: Pasajeros y Panel Premium.",
            "image": require("./../assets/STARIA/EXTERIOR/suspension-delantera.webp"),
            "position": {
              x: 1.052,
              y: 0.362,
              z: 1.683
            }
          },
          {
            "title":"SUSPENSIÓN TRASERA: MULTI LINK",
            "text": "Aplica para versiones: Pasajeros y Panel Premium.",
            "image": require("./../assets/STARIA/EXTERIOR/suspension-trasera.webp"),
            "position": {
              x: 1.052,
              y: 0.362,
              z: -1.579
            }
          },
          {
            "title":"MOTOR R2.2 CRDI",
            "text": "Mecánica de 6 velocidades Motor 2,2 VGT (Turbo de Geometría Variable) Max. Power (HP) 177 Max. Torque (kgf-m) 44.0. Con un motor 2.2 diésel, sumado a su transmisión de 6 velocidades, la nueva STARIA te permitirá tener el mejor desempeño que te ayudará a recorrer los caminos de nuestro país.",
            "image": require("./../assets/STARIA/EXTERIOR/motor.webp"),
            "position": {
              x: 0,
              y: 1.22,
              z: 2.263
            }
          },
          {
            "title":"DOMINA EL ESPACIO",
            "text": "Simplicidad, elegancia y alta tecnología resaltan en el estilo futurista de la Hyundai STARIA.",
            "image": require("./../assets/STARIA/EXTERIOR/espacio.webp"),
            "position": {
              x: 1.052,
              y: 1.010,
              z: 0.15
            }
          },
        ],
        "interior": [
          {
            "title":"DESEMPEÑO Y SEGURIDAD",
            "text": "STARIA cuenta con 2 airbags frontales, uno para el conductor y otro para el acompañante, perfectos para minimizar el daño en caso de accidentes.",
            "image": require("./../assets/STARIA/INTERIOR/seguridad.webp"),
            "position": {
              x: -0.51,
              y: 1.201,
              z: 1.111
            }
          },
          {
            "title":"CONSOLA DE ALMACENAMIENTO CENTRAL",
            "text": "Su diseño multiuso incluye una consola de almacenamiento central plegable que deja espacio para un tercer pasajero cuando se eleva junto con los refuerzos laterales del asiento, brindando un excelente apoyo y comodidad.",
            "image": require("./../assets/STARIA/INTERIOR/multiuso.webp"),
            "position": {
              x: 0,
              y: 0.907,
              z: 0.545
            }
          },
          {
            "title":"Radio + Bluetooth + USB.",
            "text": "",
            "image": require("./../assets/STARIA/INTERIOR/radio.webp"),
            "position": {
              x: -0.038,
              y: 1.16,
              z: 0.956
            }
          },
          {
            "title":"Control de mandos en el volante.",
            "text": "",
            "image": require("./../assets/STARIA/INTERIOR/mandos-volante.webp"),
            "position": {
              x: 0.452,
              y: 1.213,
              z: 0.809
            }
          },
        ]
      },

      "VENUE LIMITED AT": {
        "exterior": [
          {
            "title":"TECHO CORREDIZO Y RIELES PORTAEQUIPAJE",
            "text": "Disfruta de una vista única con el techo panorámico, que aporta luz natural y una sensación de amplitud al interior. Las barras de techo integradas complementan su diseño robusto, listas para llevar tu equipo deportivo o de viaje, haciendo de cada aventura una experiencia completa.​",
            "image": require("./../assets/VENUE/EXTERIOR/hyundai-venue-diseño-sunroof.webp"),
            "position": {
              x: 0.0,
              y: 1.65,
              z: 0.1
            }
          },
          {
            "title":"RIN DE LUJO EN ALEACIÓN DE 17''",
            "text": "Esta camioneta tiene un alto grado de atención al detalle, reflejado en cada uno de sus elementos externos, como lo son los 4 rines que se componen de una combinación de cortes geométricos rudos y elegantes, además de un alto contraste bitono en una medida de 17 pulgadas.",
            "image": require("./../assets/VENUE/EXTERIOR/rin-lujo.webp"),
            "position": {
              x: 0.88,
              y: 0.338,
              z: 1.21
            }
          },
          {
            "title":"PROTECTORES LATERALES",
            "text": "Esta camioneta tiene diferentes formas de manifestar la inteligencia como valor de Hyundai en Colombia, especialmente con sus protectores laterales que recorren a lo largo ambos costados en la parte baja más próxima al suelo; asegurando así la integridad de la carrocería, al enfrentarse a cualquier reto urbano.",
            "image": require("./../assets/VENUE/EXTERIOR/protectores-laterales.webp"),
            "position": {
              x: 0.88,
              y: 0.384,
              z: -0.061
            }
          },
          {
            "title":"LUCES DE GIRO ESTÁTICAS",
            "text": "El llamativo frontal de esta camioneta compacta, dispone de un par de luces estáticas de giro, las cuales complementan el look deportivo y dinámico exterior, sin perder la elegancia de pequeños elementos geométricos.",
            "image": require("./../assets/VENUE/EXTERIOR/luces.webp"),
            "position": {
              x: 0.687,
              y: 0.705,
              z: 1.85
            }
          },
          {
            "title":"LIMPIA PARABRISAS TRASERO",
            "text": "Como es de esperar, esta SUV ha sido pensado para facilitar la conducción de todos los que quieren vibrar su camino sin dejar a un lado la seguridad; por eso, con su limpia parabrisas trasero, asegura una visibilidad ideal de quienes transitan cerca de nosotros.",
            "image": require("./../assets/VENUE/EXTERIOR/limpia-parabrisas.webp"),
            "position": {
              x: -0.015,
              y: 1.318,
              z: -1.73
            }
          },
          {
            "title":"CC (CONTROL CRUCERO)",
            "text": "La asistencia de este sistema es una decisión conveniente de las innovaciones Hyundai inmersas en nuestros modelos; la velocidad crucero apoya la automatización de la conducción, eliminando procesos repetitivos e innecesarios al regular de forma automática la velocidad constante.",
            "image": require("./../assets/VENUE/EXTERIOR/control-crucero.webp"),
            "position": {
              x: 0.0,
              y: 1.108,
              z: 1.482
            }
          },
          {
            "title":"PDW (SENSORES PARA ALERTA DE DISTANCIA AL ESTACIONAR)",
            "text": "Finalizar el trayecto es tan satisfactorio como el inicio, por eso, te ofrecemos un conveniente juego de sensores de parqueo ubicados en su parte trasera; logrando así detectar cualquier inconveniente y prever impactos no deseados a la hora de parquear.",
            "image": require("./../assets/VENUE/EXTERIOR/pdw.webp"),
            "position": {
              x: 0,
              y: 0.518,
              z: -2.04
            }
          },
          {
            "title":"FRENOS DE DISCO EN LAS 4 RUEDAS ",
            "text": "Las 4 ruedas de esta SUV compacta, cuentan con frenos de disco ABS ajustados y personalizados a una camioneta que ofrece conducción dinámica y ligera; este sistema de frenos es el complemento ideal de nuestro sistema de seguridad presente en nuestra VENUE (El Hyundai Smart sense).",
            "image": require("./../assets/VENUE/EXTERIOR/frenos.webp"),
            "position": {
              x: 0.881,
              y: 0.475,
              z: -1.449
            }
          },
          // {
          //   "title":"TPMS (MONITOREO DE PRESIÓN DE LLANTAS)",
          //   "text": "El respaldo de seguridad de Hyundai, está presente en el sistema inmerso de monitoreo de presión en las llantas de la SUV VENUE. Esto debido gracias a su actuar es en tiempo real, efectuando una alerta en el tablero de mando, indicando la presión ideal y la presión actual de cada llanta de forma individual.",
          //   "image": require("./../assets/VENUE/EXTERIOR/tpms.webp"),
          //   "position": {
          //     x: 0.881,
          //     y: 0.141,
          //     z: -1.308
          //   }
          // }
        ],
        "interior": [
          {
            "title":"CENTRO DE ENTRETENIMIENTO DE 8''",
            "text": "Una pantalla alterna a los tableros de mando, la cual está enfocada a la conectividad y el entretenimiento que requiere una movilidad dinámica y vibrante como la de la SUV VENUE, gozando de conectividad a Apple Car Play y Android Auto; además de proyección del Smartphone en pantalla.",
            "image": require("./../assets/VENUE/INTERIOR/centro-entretenimiento.webp"),
            "position": {
              x: 0.056,
              y: 1.076,
              z: 0.511
            }
          },
          {
            "title":"TABLERO DE INSTRUMENTOS DIGITAL",
            "text": "Esta SUV presenta un tablero digital de mando, el cual tiene como objetivo impactar tus sentidos con su clúster monocromático de pantalla 4,2” LCD-TFT, la emite sus respectivos testigos de alerta para toda la seguridad activa y pasiva de la camioneta.",
            "image": require("./../assets/VENUE/INTERIOR/tablero-instrumentos.webp"),
            "position": {
              x: 0.38,
              y: 1.04,
              z: 0.6
            }
          },
          {
            "title":"BOTÓN DE ENCENDIDO",
            "text": "En este vehículo dispones de un botón de encendido, el cuál te permite encender de forma inmediata con un toque (el mismo realiza la descompresión inicial del motor, para una sana práctica de encendido), además de contar con la llave inteligente que permite encenderlo a distancia con las mismas virtudes.",
            "image": require("./../assets/VENUE/INTERIOR/boton--encendido.webp"),
            "position": {
              x: 0.144,
              y: 0.928,
              z: 0.478
            }
          },
          {
            "title":"VOLANTE INTERACTIVO",
            "text": "Gracias a sus modos de manejo, control de tracción y dirección electroasistida, ofrece una conducción cómoda incluso en carreteras irregulares.​",
            "image": require("./../assets/VENUE/INTERIOR/hyundai-venue-valante-interactivo.webp"),
            "position": {
              x: 0.371,
              y: 1.013,
              z: 0.309
            }
          },
          {
            "title":"MSLA (ASISTENTE DE LIMITADOR DE VELOCIDAD)",
            "text": "La conducción continua, que exigen tus destinos está respaldada por la tecnología de asistencia en la limitación de velocidad; logrando así que cualquier trayecto se cargue de emoción. Este sistema hace parte de la gestión de automatización del camino.",
            "image": require("./../assets/VENUE/INTERIOR/msla.webp"),
            "position": {
              x: 0.284,
              y: 1.04,
              z: 0.6
            }
          },
          {
            "title":"HAC (ASISTENTE DE ASCENSO EN PENDIENTES)",
            "text": "Uno de los elementos importantes del sistema que respalda la seguridad de la VENUE, es el asistente de ascenso en pendientes, el cual detecta en tiempo real y con su propio medidor de inclinación, cuando la camioneta se encuentra en ascenso uniforme y modifica su aceleración o avance, para realizar un frenado de emergencia y guardar la seguridad de los ocupantes.",
            "image": require("./../assets/VENUE/INTERIOR/hac.webp"),
            "position": {
              x: -0.011,
              y: 0.858,
              z: 0.337
            }
          },
          {
            "title":"DMS (SELECTOR DE MODO DE MANEJO)",
            "text": "La tecnología innovadora inmersa en esta camioneta, presenta un selector de modo de manejo compuesto, el cual te permite escoger a gusto entre 3 configuraciones predeterminadas (NORMAL, ECO y DEPORTIVO) a la vez que te da a escoger entre tres configuraciones de tracción 2WD (enfocado a terrenos con ARENA, BARRO y NIEVE).",
            "image": require("./../assets/VENUE/INTERIOR/dms.webp"),
            "position": {
              x: 0.477,
              y: 1.04,
              z: 0.6
            }
          },
          {
            "title":"6 AIRBAGS",
            "text": "Un sistema compuesto de seguridad pasiva del vehículo, en donde los sensores internos de la camioneta, detectan a los pasajeros que la ocupan y en caso de colisión, activan sus bolsas de aire que rodean de forma externa el habitáculo delantero y trasero.",
            "image": require("./../assets/VENUE/INTERIOR/air-bags.webp"),
            "position": {
              x: 0.0,
              y: 1.242,
              z: 0.657
            }
          },
          {
            "title":"CÁMARA DE REVERSA CON GUÍA DINÁMICA",
            "text": "Uno de los puntos referentes en la tecnología de apoyo de la VENUE, es la pantalla del centro de entretenimiento, que, al activar la reversa de la camioneta, proyecta de forma automática la cámara de reversa con sus guías dinámicas, pensadas en realidad aumentada.",
            "image": require("./../assets/VENUE/INTERIOR/camara-reversa.webp"),
            "position": {
              x: -0.043,
              y: 1.076,
              z: 0.511
            }
          },
          {
            "title":"ESC (CONTROL ELECTRÓNICO DE ESTABILIDAD)",
            "text": "Adicionalmente, a los sistemas de respaldo de seguridad activa de la SUV VENUE, el control electrónico de estabilidad tiene un papel protagónico en la distribución del frenado en el momento de maniobrar y reaccionar en terrenos complicados; logrando así evitar el bloqueo general de las llantas y que la camioneta puerta la adhesión al asfalto.",
            "image": require("./../assets/VENUE/INTERIOR/esc.webp"),
            "position": {
              x: 0.035,
              y: 0.89,
              z: 0.461
            }
          }
        ]
      },
      "HB20 ADVANCE": {
        "exterior": [
          {
            "title":"Parrilla Frontal",
            "text": "La nueva parrilla frontal tiene elementos paramétricos, el parachoques es más voluminoso y ahora alberga las direccionales. Los guardabarros y el capó son más horizontales, aportando una sensación de deportividad y robustez.",
            "image": require("./../assets/HB20/EXTERIOR/parrilla-frontal.webp"),
            "position": {
              x: 0.0,
              y: 0.475,
              z: 2.063
            }
          },
          {
            "title":"Espejos eléctricos",
            "text": "Color de la carrocería con direccionales incorporadas.",
            "image": require("./../assets/HB20/EXTERIOR/espejos-electricos.webp"),
            "position": {
              x: 0.9,
              y: 1.027,
              z: 0.7
            }
          },
          {
            "title":"Rin de 15” en aleación bitono",
            "text": "",
            "image": require("./../assets/HB20/EXTERIOR/rin-15.webp"),
            "position": {
              x: 0.918,
              y: 0.293,
              z: 1.2
            }
          },
          {
            "title":"Luces traseras",
            "text": "Revolucionando el diseño de las luces integradas.",
            "image": require("./../assets/HB20/EXTERIOR/luces-traseras.webp"),
            "position": {
              x: 0.676,
              y: 0.899,
              z: -1.863
            }
          },
          {
            "title":"Vista trasera renovada",
            "text": "La armonía entre el nuevo parachoques con elementos en negro mate, las luces de marcha atrás colocados en los parachoques y la tapa del maletero más grande hacen que el aspecto sea aún más tecnológico y moderno.",
            "image": require("./../assets/HB20/EXTERIOR/vista-trasera.webp"),
            "position": {
              x: 0.0,
              y: 0.813,
              z: -1.967
            }
          },
          {
            "title":"Control de crucero + Limitador de velocidad + sistema de antibloqueo de frenos (ABS) + distribución electrónica de frenado (EBD)",
            "text": "",
            "image": require("./../assets/HB20/EXTERIOR/control-crucero.webp"),
            "position": {
              x: 0.91,
              y: 0.164,
              z: 1.446
            }
          },
          {
            "title":"Control electrónico de estabilidad (ESC) + TCS (Sistema de control de tracción)",
            "text": "",
            "image": require("./../assets/HB20/EXTERIOR/estabilidad.webp"),
            "position": {
              x: 0.0,
              y: 0.974,
              z: 1.539
            }
          },
          {
            "title":"Control de asistencia al arranque en pendiente (HAC)",
            "text": "",
            "image": require("./../assets/HB20/EXTERIOR/hac.webp"),
            "position": {
              x: 0.897,
              y: 0.307,
              z: 0.0
            }
          },
        ],
        "interior": [
          {
            "title":"Centro de entretenimiento",
            "text": "Con pantalla flotante de 8” táctil, con Apple CarPlay y Android Auto, conectividad Bluetooth, reconocimiento de voz y aire acondicionado.",
            "image": require("./../assets/HB20/INTERIOR/pantalla.webp"),
            "position": {
              x: 0.0,
              y: 0.929,
              z: 0.545
            }
          },
          {
            "title":"Puerto de 12V de carga convencional + USB tipo A + Tipo C.",
            "text": "",
            "image": require("./../assets/HB20/INTERIOR/puerto-usb.webp"),
            "position": {
              x: 0.073,
              y: 0.696,
              z: 0.39
            }
          },
          {
            "title":"Comodidad y un gran viaje",
            "text": "El nuevo diseño del tablero HB20 permanece en armonía con las otras características tecnológicas del interior.",
            "image": require("./../assets/HB20/INTERIOR/tablero.webp"),
            "position": {
              x: 0.0,
              y: 0.831,
              z: 0.432
            }
          },
          {
            "title":"Control de mandos de retrovisores y vidrios eléctricos",
            "text": "Con función de anti aprisionamiento en el vidrio del conductor.",
            "image": require("./../assets/HB20/INTERIOR/vidrios-electricos.webp"),
            "position": {
              x: 0.654,
              y: 0.65,
              z: 0.363
            }
          },
          {
            "title":"Detalles y acabados",
            "text": "Mayor refinamiento como el volante interactivo con comandos de voz.",
            "image": require("./../assets/HB20/INTERIOR/volante.webp"),
            "position": {
              x: 0.47,
              y: 0.916,
              z: 0.292
            }
          },
          {
            "title":"Airbags",
            "text": "6 bolsas de aire (airbags): 2 Frontales + 2 Tipo Cortina + 2 Laterales de Tórax.",
            "image": require("./../assets/HB20/INTERIOR/airbag.webp"),
            "position": {
              x: -0.372,
              y: 0.925,
              z: 0.508
            }
          },
          {
            "title":"Cámara de reversa",
            "text": "",
            "image": require("./../assets/HB20/INTERIOR/camara-reversa.webp"),
            "position": {
              x: 0.0,
              y: 1.03,
              z: 0.581
            }
          },
        ]
      },
      "HB20S ADVANCE": {
        "exterior": [
          {
            "title":"Parrilla Frontal",
            "text": "La nueva parrilla frontal tiene elementos paramétricos, el parachoques es más voluminoso y ahora alberga las direccionales. Los guardabarros y el capó son más horizontales, aportando una sensación de deportividad y robustez.",
            "image": require("./../assets/HB20/EXTERIOR/parrilla-frontal.webp"),
            "position": {
              x: 0.0,
              y: 0.45,
              z: 2.167
            }
          },
          {
            "title":"Espejos eléctricos",
            "text": "Color de la carrocería con direccionales incorporadas.",
            "image": require("./../assets/HB20/EXTERIOR/espejos-electricos.webp"),
            "position": {
              x: 0.944,
              y: 0.992,
              z: 0.8
            }
          },
          {
            "title":"Rin de 15” en aleación bitono",
            "text": "",
            "image": require("./../assets/HB20/EXTERIOR/rin-15.webp"),
            "position": {
              x: 0.9,
              y: 0.302,
              z: 1.302
            }
          },
          {
            "title":"Luces traseras",
            "text": "Revolucionando el diseño de las luces integradas.",
            "image": require("./../assets/HB20/EXTERIOR/luces-traseras.webp"),
            "position": {
              x: 0.614,
              y: 0.873,
              z: -2.06
            }
          },
          {
            "title":"Vista trasera renovada",
            "text": "La armonía entre el nuevo parachoques con elementos en negro mate, las luces de marcha atrás colocados en los parachoques y la tapa del maletero más grande hacen que el aspecto sea aún más tecnológico y moderno.",
            "image": require("./../assets/HB20/EXTERIOR/vista-trasera.webp"),
            "position": {
              x: 0.0,
              y: 0.764,
              z: -2.137
            }
          },
          {
            "title":"Control de crucero + Limitador de velocidad + sistema de antibloqueo de frenos (ABS) + distribución electrónica de frenado (EBD)",
            "text": "",
            "image": require("./../assets/HB20/EXTERIOR/control-crucero.webp"),
            "position": {
              x: 0.911,
              y: 0.128,
              z: 1.531
            }
          },
          {
            "title":"Control electrónico de estabilidad (ESC) + TCS (Sistema de control de tracción)",
            "text": "",
            "image": require("./../assets/HB20/EXTERIOR/estabilidad.webp"),
            "position": {
              x: 0.0,
              y: 0.962,
              z: 1.668
            }
          },
          {
            "title":"Control de asistencia al arranque en pendiente (HAC)",
            "text": "",
            "image": require("./../assets/HB20/EXTERIOR/hac.webp"),
            "position": {
              x: 0.89,
              y: 0.278,
              z: 0.0
            }
          },
        ],
        "interior": [
          {
            "title":"Centro de entretenimiento",
            "text": "Con pantalla flotante de 8” táctil, con Apple CarPlay y Android Auto, conectividad Bluetooth, reconocimiento de voz y aire acondicionado.",
            "image": require("./../assets/HB20/INTERIOR/pantalla.webp"),
            "position": {
              x: 0.0,
              y: 0.927,
              z: 0.632
            }
          },
          {
            "title":"Puerto de 12V de carga convencional + USB tipo A + Tipo C.",
            "text": "",
            "image": require("./../assets/HB20/INTERIOR/puerto-usb.webp"),
            "position": {
              x: 0.063,
              y: 0.688,
              z: 0.496
            }
          },
          {
            "title":"Comodidad y un gran viaje",
            "text": "El nuevo diseño del tablero HB20 permanece en armonía con las otras características tecnológicas del interior.",
            "image": require("./../assets/HB20/INTERIOR/tablero.webp"),
            "position": {
              x: 0.0,
              y: 0.843,
              z: 0.543
            }
          },
          {
            "title":"Control de mandos de retrovisores y vidrios eléctricos",
            "text": "Con función de anti aprisionamiento en el vidrio del conductor.",
            "image": require("./../assets/HB20/INTERIOR/vidrios-electricos.webp"),
            "position": {
              x: 0.639,
              y: 0.63,
              z: 0.464
            }
          },
          {
            "title":"Detalles y acabados",
            "text": "Mayor refinamiento como el volante interactivo con comandos de voz.",
            "image": require("./../assets/HB20/INTERIOR/volante.webp"),
            "position": {
              x: 0.454,
              y: 0.933,
              z: 0.388
            }
          },
          {
            "title":"Airbags",
            "text": "6 bolsas de aire (airbags): 2 Frontales + 2 Tipo Cortina + 2 Laterales de Tórax.",
            "image": require("./../assets/HB20/INTERIOR/airbag.webp"),
            "position": {
              x: -0.368,
              y: 0.912,
              z: 0.614
            }
          },
          {
            "title":"Cámara de reversa",
            "text": "",
            "image": require("./../assets/HB20/INTERIOR/camara-reversa.webp"),
            "position": {
              x: 0.0,
              y: 1.0,
              z: 0.68
            }
          },
        ]
      },

      "CRETA PREMIUM": {
        "exterior": [
          {
            "title":"LUCES TRASERAS COMBINADAS LED",
            "text": "La nueva Creta es un concepto compacto en su diseño exterior, el cual en su respaldo presenta unas luces traseras combinadas de tipología LED, con su diseño de líneas compuestas con vértices agresivos, comunicando una estética distintiva de nuestros vehículos innovadores.",
            "image": require("./../assets/CRETA/EXTERIOR/creta-luces-traseras.webp"),
            "position": {
              x: 0.752,
              y: 0.958,
              z: -2.024
            }
          },
          {
            "title":"LUCES DELANTERAS LED (4MFR)",
            "text": "Esta SUV cuenta con farolas delanteras estratégicamente ubicadas en sus vértices frontales, las cuales ofrecen una visibilidad mejorada en la proyección del camino. Cuentan con tecnología de estilo futurista por sus líneas delgadas que recorren las luminarias, además de ser tipo LED.",
            "image": require("./../assets/CRETA/EXTERIOR/creta-luces-delanteras.webp"),
            "position": {
              x: 0.732,
              y: 0.827,
              z: 1.976
            }
          },
          {
            "title":"DIRECCIONALES INTEGRADAS EN LOS ESPEJOS",
            "text": "El diseño externo de esta SUV, exige que cada detalle de ella presente un alto grado de planeación en su influencia en el confort, seguridad y estilo. Así es como se ubican las direccionales LED laterales en la composición misma de los espejos, las cuales además cuentan con función de plegado eléctrico desde el habitáculo.",
            "image": require("./../assets/CRETA/EXTERIOR/creta-direccionales.webp"),
            "position": {
              x: 1.024,
              y: 1.2,
              z: 0.697
            }
          },
          {
            "title":"RIN DE LUJO EN ALEACIÓN BITONO DE 17”",
            "text": "La nueva CRETA en Colombia, cuenta con rines pensados para un desempeño dinámico y agresivo en los terrenos; con sus rines de 17 pulgadas compuestos por cortes en forma de diamante, los cuales presentan un contraste alto en bitono, vistiéndose de plata y negro perlado.",
            "image": require("./../assets/CRETA/EXTERIOR/creta-rin-lujo.webp"),
            "position": {
              x: 0.941,
              y: 0.363,
              z: 1.319
            }
          },
          {
            "title":"RIELES EN EL TECHO",
            "text": "Para su desempeño exigente, esta camioneta cuenta con dos rieles que recorren el auto a lo largo en el techo, los cuales proveen una capacidad de carga de 80 kg; además de aportar al diseño exterior que busca comunicar un concepto deportivo y seguro, a pesar de su gran tamaño general.",
            "image": require("./../assets/CRETA/EXTERIOR/creta-rieles-techo.webp"),
            "position": {
              x: 0.566,
              y: 1.70,
              z: -0.581
            }
          },
          {
            "title":"LIMPIA PARABRISAS TRASERO",
            "text": "La visibilidad del camino es valiosa por su cubrimiento en todos los frentes posibles que interviene un vehículo; por eso nuestra CRETA cuenta con un limpia brisas trasero, el cual te brinda la oportunidad de asegurar tu visibilidad del panorámico trasero. Así mismo aseguras tu visibilidad.",
            "image": require("./../assets/CRETA/EXTERIOR/creta-limpia-parabrisas-trasero2.webp"),
            "position": {
              x: 0.0,
              y: 1.267,
              z: -2.135
            }
          },
          {
            "title":"CC (CONTROL CRUCERO)",
            "text": "Una tecnología que mantiene la velocidad constante del vehículo, permitiéndote disfrutar del paisaje sin preocuparte por mantener el ritmo. Es la libertad de relajarte, de absorber el mundo que te rodea y de estar en sintonía con la carretera.",
            "image": require("./../assets/CRETA/EXTERIOR/creta-control-crucero.webp"),
            "position": {
              x: 0.0,
              y: 1.228,
              z: 1.072
            }
          },
          {
            "title":"FRENOS DE DISCO EN LAS 4 RUEDAS",
            "text": "El sistema de frenos principal de la nueva creta, es una conjunción de acciones tecnológicas pensadas para reducir el calor que genera en la acción de frenado. Logrando así una distribución eficiente en la temperatura del disco y así mismo, un accionar consistente para asegurar una detención eficaz.",
            "image": require("./../assets/CRETA/EXTERIOR/creta-frenos-disco.webp"),
            "position": {
              x: 0.948,
              y: 0.552,
              z: -1.475
            }
          },
          {
            "title":"PDW (SENSORES PARA ALERTA DE DISTANCIA AL ESTACIONAR)",
            "text": "Los sensores de estacionamiento no solo son una característica técnica, sino un aliado de tranquilidad que te brinda la seguridad de aparcar con destreza, sin estrés y sin sorpresas desagradables. Son como un susurro constante que te guía, evitando que te preocupes por golpes o daños no deseados.",
            "image": require("./../assets/CRETA/EXTERIOR/creta-pdw.webp"),
            "position": {
              x: 0.0,
              y: 0.55,
              z: -2.245
            }
          },
          {
            "title":"TPMS (MONITOREO DE PRESIÓN DE LLANTAS)",
            "text": "Un indicador de seguridad activo constantemente, el cual te muestra la medida exacta de presión de cada una de las llantas, además de especificar la posición de la llanta que presente un nivel irregular en sus dimensiones de aire interno. Este proceso asegura una correcta gestión de la presión de los neumáticos y su desempeño.",
            "image": require("./../assets/CRETA/EXTERIOR/creta-tpms.webp"),
            "position": {
              x: 0.948,
              y: 0.218,
              z: -1.163
            }
          },
          {
            "title":"HAC (ASISTENTE DE ASCENSO EN PENDIENTES)",
            "text": "Un sistema que te asiste en tiempo real con los trayectos de pendientes pronunciadas, en donde encuentras una respuesta de aproximadamente uno a dos segundos, pasando a la detención total del vehículo cuando detecta una suspensión irregular de la aceleración en subida.",
            "image": require("./../assets/CRETA/EXTERIOR/creta-hac.webp"),
            "position": {
              x: 0.0,
              y: 0.879,
              z: -2.21
            }
          },
          {
            "title":"ESC (CONTROL ELECTRÓNICO DE ESTABILIDAD)",
            "text": "El control de estabilidad es como un fiel guardián que te acompaña en cada curva y giro del camino. Imagina estar en una carretera, enfrentando condiciones desafiantes, sentir que tu vehículo se mantiene firme y seguro. Es un sistema avanzado invisible pero poderoso, trabajando incansablemente para mantener tu vehículo en la trayectoria correcta, incluso en terrones resbaladizos o situaciones de emergencia.",
            "image": require("./../assets/CRETA/EXTERIOR/creta-esc.webp"),
            "position": {
              x: 0.0,
              y: 0.413,
              z: 2.224
            }
          }
        ],
        "interior": [
          {
            "title":"CENTRO DE ENTRETENIMIENTO DE 8”",
            "text": "La tecnología de Hyundai se manifiesta en su centro de entretenimiento, con una pantalla de 8 pulgadas alterna a los tableros de mando, con conectividad a Apple Car Play y Android Auto, comando de voz, conectividad bluetooth y mandos en el timón.",
            "image": require("./../assets/CRETA/INTERIOR/creta-centro-entretenimiento.webp"),
            "position": {
              x: 0.0,
              y: 1.06,
              z: 0.553
            }
          },
          {
            "title":"CONSOLA CENTRAL CON DESCANSA-BRAZOS",
            "text": "El habitáculo interno de la nueva CRETA para Colombia, es un concepto de diseño enfocado al confort y el espacio amplio para distribuir sus necesidades de convivencia con el vehículo; aquí es donde resalta su consola central con el descansa-brazos integrado que complementa las amplias líneas de espacio horizontal.",
            "image": "",
            "position": {
              x: 0.0,
              y: 0.944,
              z: -0.06
            }
          },
          {
            "title":"AIRE ACONDICIONADO CON FILTRO Y PURIFICADOR DE AIRE",
            "text": "El control de temperatura de esta SUV es un sistema completamente automatizado que facilita la manipulación de la sensación térmica que provee la camioneta internamente a todos los pasajeros; adicional cuenta con un sistema de filtrado y purificación del aire suministrado para este propósito.",
            "image": require("./../assets/CRETA/INTERIOR/creta-aire-acondicionado.webp"),
            "position": {
              x: 0.0,
              y: 0.908,
              z: 0.5
            }
          },
          {
            "title":"BOTÓN DE ENCENDIDO",
            "text": "Este vehículo en su parte interna de iniciación cuenta con un botón de encendido directo, el cual te ayuda a minimizar el esfuerzo para iniciar tu marcha. Esta tecnología además se complementa con la llave inteligente del vehículo, el cual se puede iniciar a distancia con ella.",
            "image": require("./../assets/CRETA/INTERIOR/boton-encendido.webp"),
            "position": {
              x: 0.23,
              y: 0.98,
              z: 0.543
            }
          },
          {
            "title":"VENTANAS CON UN TOQUE DE SUBIDA Y UN TOQUE DE BAJADA",
            "text": "Pensando en la conveniencia y comodidad que provee esta camioneta a sus ocupantes, ubicamos botones de activación de un toque para la subida y bajada de las ventanas laterales; estos botones cumplen con el valor estético que exige la línea fluida de diseño interno de esta SUV.",
            "image": require("./../assets/CRETA/INTERIOR/creta-ventanas.webp"),
            "position": {
              x: 0.65,
              y: 1.021,
              z: 0.427
            }
          },
          {
            "title":"LUZ DE LECTURA DE MAPA, LUZ DE BAÚL Y LUZ DE SALÓN",
            "text": "Habitar y convivir con la nueva CRETA es un concepto que se evidencia completamente en cada detalle de la camioneta, como en la iluminación interna adaptada a propósitos de lectura de mapas, visibilidad del baúl y las guanteras y la luz general de salón para todo el habitáculo.",
            "image": require("./../assets/CRETA/INTERIOR/creta-luz-lectura.webp"),
            "position": {
              x: 0.0,
              y: 1.51,
              z: 0.218
            }
          },
          {
            "title":"CÁMARA DE REVERSA CON GUÍA DINÁMICA",
            "text": "Al parquear, la nueva CRETA te asiste automáticamente con una visibilidad nítida que parte de la cámara trasera de la camioneta, lo cual te asegura un correcto parqueo sin presentar posibles inconvenientes en tu vehículo ni el de los demás.",
            "image": require("./../assets/CRETA/INTERIOR/creta-camara-reversa.webp"),
            "position": {
              x: 0.0,
              y: 1.1,
              z: 0.64
            }
          },
          {
            "title":"6 AIRBAGS",
            "text": "Esta camioneta está planeada con protección envolvente para todos los pasajeros del vehículo, esto debido a que dispones de 6 airbags estratégicamente ubicados (dos airbags frontales, dos airbags laterales y dos airbags de cortina), los cuales no solo representan tecnología avanzada, sino también la promesa de mantener a salvo a ti y a tus seres queridos. Con un escudo silencioso que te da la confianza de que, en cualquier situación inesperada, estarás rodeado de protección.",
            "image": require("./../assets/CRETA/INTERIOR/creta-airbags.webp"),
            "position": {
              x: 0.373,
              y: 1.113,
              z: 0.373
            }
          }
        ]
      },
      "KONA HEV LIMITED": {
        "exterior": [
          {
            "title":"FAROS DELANTEROS, 100% LED TIPO MFR",
            "text": "La iluminación LED ofrece una claridad y una visibilidad superior en comparación con las luces halógenas tradicionales, permitiendo a nuestros conductores ver más lejos y con mayor claridad durante la noche o en condiciones de baja visibilidad asegurando una mejor conducción para ti y todos los que transitan el camino.",
            "image": require("./../assets/KONA/EXTERIOR/HME_SX2_HEV_360_EXT_A2B-Abyss_Black_Pearl_EWAAXA_134.webp"),
            "position": {
              x: 0.857,
              y: 0.66,
              z: 1.95
            }
          },
          {
            "title":"LUCES TRASERAS COMBINADAS LED",
            "text": "Tienen un diseño moderno, elegante y futurista, con una iluminación línea horizontal de alto impacto, el cual ofrece una visibilidad excepcional, asegurando que otros conductores puedan ver esta camioneta desde una distancia significativa, tanto en el día como en la noche.",
            "image": require("./../assets/KONA/EXTERIOR/HME_SX2_HEV_360_EXT_A2B-Abyss_Black_Pearl_EWAAXA_116.webp"),
            "position": {
              x: 0.857,
              y: 0.666,
              z: -1.945
            }
          },
          {
            "title":"RINES 17” Y 18” PARA MAYOR IMPACTO EN LA CIUDAD",
            "text": "Dos versiones para esta SUV híbrida, donde cada una te ofrece un rin de 17 y 18 pulgadas para sus versiones Premium y Limited respectivamente; ambas versiones compuestas por rines de aleación, con un variante bitono para la versión Limited.",
            "image": require("./../assets/KONA/EXTERIOR/Rines.webp"),
            "position": {
              x: 0.926,
              y: 0.359,
              z: 1.331
            }
          },
          {
            "title":"PALETA FRONTAL AUTOMÁTICA DE AIRE, PARA UN ENFRIAMIENTO ACTIVO",
            "text": "Un mecanismo automático en su apertura y cierre, el cual permite a la nueva KONA circular mientras reduce su resistencia al enfriamiento, garantizando un rendimiento óptimo y una mayor eficiencia energética; además de complementar el imponente frente estético, respaldando su línea horizontal sutil y elegante.",
            "image": require("./../assets/KONA/EXTERIOR/SX2_KONA_K5_RHD_EXTERIOR_PIXELATED_SEAMLESS_HORIZON_LAMP.webp"),
            "position": {
              x: 0.0,
              y: 0.793,
              z: 2.22
            }
          },
          {
            "title":"ESPEJOS, ADAPTADOS A UNA VISTA ELEGANTE Y VERSÁTIL",
            "text": "Este espejo no es solo un simple reflejo de lo que queda atrás; es una herramienta de seguridad avanzada que se ajusta automáticamente para minimizar el deslumbramiento de los faros traseros durante la noche, protegiendo así la visión del conductor. Esta tecnología asegura que, independientemente de las condiciones externas, el conductor tenga una visibilidad mejorada y continua del entorno detrás del vehículo para que aumente la seguridad en la conducción nocturna. (versión Limited).",
            "image": require("./../assets/KONA/EXTERIOR/SX2_KONA_K5_RHD_FEATURE_BODY_COLORED_OUTSIDE_MIRROR.webp"),
            "position": {
              x: 1.024,
              y: 1.125,
              z: 0.647
            }
          },
          {
            "title":"RIELES PORTAEQUIPAJE EN EL TECHO",
            "text": "Como cada una de las decisiones innovadoras de Hyundai en sus vehículos, te ofrecemos dos rieles verticales que recorren la extensión del techo de esta camioneta, permitiéndote incrementar la capacidad de transportar más de lo necesario para la exploración de tus destinos, además de ser parte del color asignado para el techo, complementando su acabado general estético de lujo.",
            "image": require("./../assets/KONA/EXTERIOR/SX2_KONA_K5_RHD_FEATURE_WIDE_SUNROOF.webp"),
            "position": {
              x: 0.531,
              y: 1.62,
              z: -0.351
            }
          },
          {
            "title":"SENSORES DE PARQUEO DELANTEROS Y TRASEROS",
            "text": "Al adquirir el compromiso sostenible conduciendo esta nueva KONA, recibes una visión en tiempo real que cuenta con 6 sensores independientes, los cuales permiten construir una imagen abierta y realista de la parte frontal y trasera a la hora de parquear; asegurando la finalización eficiente y exitosa de tu destino.",
            "image": require("./../assets/KONA/EXTERIOR/SX2_KONA_K5_RHD_FEATURE_BCA.webp"),
            "position": {
              x: 0.0,
              y: 0.427,
              z: 2.236
            }
          },
          {
            "title":"AMPLIACIÓN DE CAPACIDAD VERTICAL DEL BAÚL",
            "text": "Entendemos la importancia de contar con un espacio versátil y funcional para satisfacer tus necesidades y las de tu familia, por ello, esta nueva SUV cuenta con un innovador sistema de baúl graduable a 2 niveles, logrando aumentar la capacidad en volumen según tus necesidades.",
            "image": require("./../assets/KONA/EXTERIOR/SX2_KONA_K5_RHD_INTERIOR_2ND_ROW_60_40_SPLIT_FOLDING_SEATS.webp"),
            "position": {
              x: 0.0,
              y: 1.022,
              z: -2.187
            }
          },
          {
            "title":"MOTOR FULL HÍBRIDO, NO ENCHUFABLE",
            "text": "Esta innovadora SUV de tamaño B, está equipada con dos motores, un motor a gasolina de inyección electrónica de 1.6 L con 4 cilindros en línea que entrega una potencia de 103,5 HP y un torque de 144,2 Nm. Su segundo motor es un motor eléctrico que entrega una potencia de 43 HP y un torque instantáneo de 170 Nm; logrando así una conducción más ágil y divertida, que, combinado con una autonomía extendida, se convierte en una opción ideal para disfrutar de una experiencia eficiente, emocionante y consciente del medio ambiente.",
            "image": require("./../assets/KONA/EXTERIOR/Motor Full Hibrido.webp"),
            "position": {
              x: 0.0,
              y: 1.076,
              z: 1.789
            }
          },
          {
            "title":"E-MOTION DRIVE, TECNOLOGÍA HYUNDAI EXCLUSIVA PARA VEHÍCULOS HÍBRIDOS Y ELÉCTRICOS",
            "text": "Este sistema inteligente no solo optimiza la energía y la eficiencia, sino que también ayuda a prevenir el subviraje (que es cuando el vehículo no gira lo suficiente en una curva y tiende a seguir recto), manteniendo a tu familia segura en cada curva. Al integrar de manera perfecta el motor eléctrico y el motor de combustión interna, 'e-motion drive' te brinda un rendimiento suave y dinámico, mientras cuidas del medio ambiente y ahorras en combustible.",
            "image": require("./../assets/KONA/EXTERIOR/SX2_KONA_K5_RHD_FEATURE_ENHANCED_ROAD_NOISE_REDUCTION.webp"),
            "position": {
              x: 0.911,
              y: 0.526,
              z: -1.541
            }
          },
          {
            "title":"FCA - ASISTENTE DE COLISIÓN FRONTAL",
            "text": "Nuestro sistema de anticipación de colisiones utiliza un radar frontal y una cámara para detectar posibles peligros con otros vehículos, peatones y ciclistas. ¿El resultado? Señales de advertencia instantáneas y asistencia de frenado automático que te ayudan a evitar accidentes. Un sistema que termina de complementar toda la seguridad activa de esta innovadora camioneta (versión Limited).",
            "image": require("./../assets/KONA/EXTERIOR/SX2_KONA_K5_RHD_FEATURE_FCA.webp"),
            "position": {
              x: 0.412,
              y: 0.427,
              z: 2.236
            }
          },
          {
            "title":"LKA Y LFA, ASISTENTES DE MANTENIMIENTO Y SEGUIMIENTO DE CARRIL",
            "text": "Este conjunto de sistemas de asistencias activas a la seguridad, se encargan de detectar cualquier desviación del carril sin el uso de la direccional correspondiente, automáticamente él asiste en la dirección para evitar que el vehículo se salga del camino (LKA) y gracias a una cámara de vista frontal, este sistema reconoce los marcadores de carril y los vehículos, para luego, guiar suavemente tu vehículo al centro del carril (LFA) (versión Limited).",
            "image": require("./../assets/KONA/EXTERIOR/SX2_KONA_K5_RHD_FEATURE_LKA.webp"),
            "position": {
              x: -0.438,
              y: 1.312,
              z: 0.745
            }
          }
          ,
          {
            "title":"HAC - ASISTENTE DE ASCENSO EN PENDIENTES",
            "text": "Más innovación y seguridad activa en esta nueva camioneta, encontrarás el Asistente de Ascenso en Pendientes, el cual analiza la inclinación del camino y permite detenerse en pendientes pronunciadas, para después volver arrancar teniendo la certeza que el vehículo no va a retroceder, brindando la seguridad y la tranquilidad que necesitas para disfrutar al máximo cada viaje con tu familia.",
            "image": require("./../assets/KONA/EXTERIOR/SX2_KONA_HEV_K5_RHD_EXTERIOR_E_MOTION_DRIVE_MAIN.webp"),
            "position": {
              x: 0.0,
              y: 1.312,
              z: 0.745
            }
          }
          ,
          {
            "title":"SSC - CONTROL CRUCERO INTELIGENTE",
            "text": "En el conjunto de sistemas de tecnologías ADAS, encontramos que esta nueva camioneta posee el asistente Control Crucero Inteligente, el cual, con su equipo de sensores delanteros y traseros, reconoce los vehículos más próximos y ajusta una velocidad constante a gusto del conductor; logrando así un ahorro en la gestión de combustible y recursos del vehículo, además de automatizar procesos al volante (versión Limited).",
            "image": require("./../assets/KONA/EXTERIOR/SX2_KONA_K5_RHD_FEATURE_LFA.webp"),
            "position": {
              x: 0.0,
              y: 1.522,
              z: 0.388
            }
          }
          ,
          {
            "title":"BCA - ASISTENTE DE COLISIÓN EN PUNTO CIEGO TRASERO",
            "text": "Mientras cambias de carril con tu direccional activa, nuestro sistema automático de frenado detecta cualquier posible colisión con vehículos en los puntos ciegos traseros, le avisará y podría aplicar automáticamente el freno de la rueda delantera derecha o izquierda antes de que cambie de carril, para mantenerte protegido a ti y a tus acompañantes (versión Limited).",
            "image": require("./../assets/KONA/EXTERIOR/SX2_KONA_K5_RHD_FEATURE_BCA.webp"),
            "position": {
              x: 0.0,
              y: 0.414,
              z: -2.198
            }
          }
          ,
          {
            "title":"ESC - CONTROL ELECTRÓNICO DE ESTABILIDAD",
            "text": "En la nueva generación de esta innovadora SUV, cuentas con el asistente de Control Electrónico de Estabilidad, el cual te asegura un respaldo efectivo y activo en tiempo real, a la hora de realizar maniobras de emergencia; asegurando así entre tu camioneta y tú, el bienestar de todos tus acompañantes en el camino.",
            "image": require("./../assets/KONA/EXTERIOR/SX2_KONA_HEV_K5_RHD_EXTERIOR_MULTI_LINK_REAR_SUSPENSION.webp"),
            "position": {
              x: 0.0,
              y: 1.155,
              z: 1.070
            }
          }
          ,
          {
            "title":"FRENADO REGENERATIVO INTELIGENTE",
            "text": "Cuando conduces sin presionar el pedal del acelerador, nuestro sistema se encarga automáticamente de controlar el frenado regenerativo, adaptándose a la pendiente de la carretera y a las condiciones del tráfico, esto con el fin de generar energía de carga para el motor eléctrico, por medio del accionar del sistema de frenado el cual regenera la energía utilizada (versión Limited).",
            "image": require("./../assets/KONA/EXTERIOR/SX2_KONA_K5_RHD_FEATURE_ENHANCED_ROAD_NOISE_REDUCTION.webp"),
            "position": {
              x: 0.93,
              y: 0.362,
              z: -1.181
            }
          }
        ],
        "interior": [
          {
            "title":"TABLERO DE INSTRUMENTOS Y CENTRO DE ENTRETENIMIENTO",
            "text": "Con una pantalla curva unificada en un recorrido horizontal de 12,3” (la cual hace parte del diseño del habitáculo principal, que está enfocado en su totalidad al conductor) dispones de una proyección intuitiva para el tablero de instrumentos junto al centro de entretenimiento; todo en una sola disposición para maximizar la eficiencia de concentración en la conducción.",
            "image": require("./../assets/KONA/INTERIOR/SX2_KONA_K5_RHD_INTERIOR_PANORAMIC_DISPLAY.webp"),
            "position": {
              x: -0.027,
              y: 0.985,
              z: 0.621
            }
          },
          {
            "title":"SMART SHIFT LEVER, ELECTRÓNICAMENTE INTELIGENTE",
            "text": "Nuestra Smart Shift Lever (palanca selectora de marchas inteligente), discretamente ubicada en la columna de dirección, esta característica, no solo te brinda un manejo más intuitivo y ergonómico, sino que también libera espacio en el interior de tu vehículo para una experiencia de conducción más elegante y cómoda para ti y tu familia.",
            "image": require("./../assets/KONA/INTERIOR/SX2_KONA_K5_RHD_INTERIOR_COLUMN_TYPE_SHIFT_BY_WIRE.webp"),
            "position": {
              x: 0.23,
              y: 0.973,
              z: 0.422
            }
          },{
            "title":"CARGADOR INALÁMBRICO",
            "text": "Un sistema innovador acorde a las nuevas corrientes de desarrollo tecnológico para la movilidad, esta camioneta cuenta con una unidad de carga inalámbrica que permite el acople de múltiples dispositivos smartphones; logrando crear un ecosistema libre de cables y conexiones obligatorias, mientras sé redirige eficientemente toda la energía producida por la camioneta a nuestros dispositivos.",
            "image": require("./../assets/KONA/INTERIOR/SX2_KONA_K5_RHD_FEATURE_SMARTPHONE_WIRELESS_CHARGING.webp"),
            "position": {
              x: 0.0,
              y: 0.773,
              z: 0.558
            }
          },{
            "title":"COJINERÍA EN CUERO Y ECO CUERO",
            "text": "La innovación también se viste elegante, sin sacrificar su comodidad y facilidad de mantenerse agradable y presentable; esto define a la cojinería interna de nuestra nueva KONA Híbrida, donde encuentras en todos sus 5 asientos, una composición en su totalidad de eco-cuero para la versión Premium y cuero para la versión Limited.",
            "image": require("./../assets/KONA/INTERIOR/SX2_KONA_K5_RHD_INTERIOR_2ND_ROW_SEATBACK.webp"),
            "position": {
              x: -0.355,
              y: 0.716,
              z: 0.256
            }
          },{
            "title":"LEVAS EN EL VOLANTE, OPTIMIZACIÓN MÁXIMA AL VOLANTE",
            "text": "Ya sea que desees un manejo deportivo o una conducción más eficiente, nuestras levas en el volante te permiten cambiar de marchas con precisión o ajustar los niveles de intensidad del frenado regenerativo con facilidad, dependiendo del modo de manejo seleccionado previamente.",
            "image": require("./../assets/KONA/INTERIOR/SX2_KONA_K5_RHD_FEATURE_PADDLE_SHIFTERS.webp"),
            "position": {
              x: 0.334,
              y: 1.032,
              z: 0.432
            }
          },{
            "title":"CÁMARA DE REVERSA CON GUÍAS DINÁMICAS Y DOBLE VISUALIZACIÓN",
            "text": "Apoyando el sistema de sensores en los bordes externos, esta camioneta te provee de una cámara de reversa dotada de guías dinámicas, para un correcto dimensionamiento del espacio seguro a la hora de parquear y finalizar tu trayecto; y gracias al modo adicional de visualización que enfoca su vista hacia el piso, podrás ver cualquier obstáculo o peligro que se encuentre en tu camino mientras retrocedes.",
            "image": require("./../assets/KONA/INTERIOR/SX2_KONA_K5_RHD_FEATURE_SURROUND_VIEW_MONITOR .webp"),
            "position": {
              x: 0.0,
              y: 1.11,
              z: 0.647
            }
          },{
            "title":"AJUSTE ELÉCTRICO DE SILLA DE CONDUCTOR, TECNOLOGÍA AL SERVICIO",
            "text": "En esta SUV dispones de un asiento del conductor (versión Limited) dotado con botones que accionan electrónicamente el ajuste de inclinación, posición y elevación en ella, así asegurando la personalización más completa a la hora de sentarte a abordar los caminos.",
            "image": require("./../assets/KONA/INTERIOR/SX2_KONA_K5_RHD_FEATURE_8WAY_POWERED_DRIVER_SEAT.webp"),
            "position": {
              x: 0.126,
              y: 0.7,
              z: 0.274
            }
          },{
            "title":"BOTÓN ELECTRÓNICO DE PARQUEO, SENCILLAMENTE EFECTIVO Y SEGURO",
            "text": "Como sustitución a la palanca de freno de mano convencional, dispones de un botón electrónico que suaviza la interacción con tu vehículo, asegurando el correcto bloqueo general de los frenos para un aparcamiento o pausa de la marcha con completa seguridad.",
            "image": require("./../assets/KONA/INTERIOR/BotonElectronicoParqueo_upscayl_3x_realesrgan-x4plus.webp"),
            "position": {
              x: 0.099,
              y: 0.703,
              z: 0.438
            }
          },{
            "title":"6 AIRBAGS",
            "text": "La conducción responsable está respaldada por la seguridad pasiva de esta innovadora SUV, encabezada por los 6 airbags que están ubicados estratégicamente alrededor de los dos niveles del habitáculo general para todos los pasajeros (dos frontales: uno para el piloto y otro para el copiloto, dos tipos cortina y dos laterales).",
            "image": require("./../assets/KONA/INTERIOR/AIRBAGS.webp"),
            "position": {
              x: -0.47,
              y: 0.885,
              z: 0.608
            }
          },{
            "title":"BOTÓN DE ENCENDIDO Y SMART KEY AUTOMÁTICA EMBLEMÁTICA HYUNDAI",
            "text": "Con la Smart Key Automática de la nueva KONA, puedes accionar la apertura, el cierre y el arranque del vehículo sin tocarlo; además de su sistema interno del botón de encendido, optimizando las interacciones táctiles para sentir la vibra de una conducción responsable.",
            "image": require("./../assets/KONA/INTERIOR/PLATINUMPLUSBOTÃOSTARTSTOP.webp"),
            "position": {
              x: 0.138,
              y: 0.901,
              z: 0.616
            }
          },{
            "title":"MODOS DE MANEJO: ECO, SPORT Y NIEVE",
            "text": "Entendiendo que cada conductor es único, al igual que cada viaje, la nueva Kona agrega en su menú de diversidad tecnológica, 3 modos de manejo para adaptarse a las necesidades y preferencias de conductor (ECO, SPORT y NIEVE) asegurando que cada experiencia al volante sea personal, eficiente y sobre todo, divertida.",
            "image": require("./../assets/KONA/INTERIOR/SX2_KONA_K5_RHD_FEATURE_DRIVE_MODE.webp"),
            "position": {
              x: 0.0,
              y: 0.703,
              z: 0.44
            }
          },
          
        ]
      },

      "SANTA FE HEV LIMITED 4x4": {
        "exterior": [
          {
            "title":"Motor que te mueve a otro nivel",
            "text": "Cuenta con dos motores: uno de combustión con 177,5 Hp y otro eléctrico con 59,3 Hp, ofreciendo una potencia combinada de 232 Hp. Disfruta de una conducción emocionante gracias al motor turbo de 1.6 litros y 4 cilindros, combinado con el motor eléctrico de 44.2 kW.",
            "image": require("./../assets/SANTAFE/EXTERIOR/santafe-hibrida-frontal.webp"),
            "position": {
              x: 0.0,
              y: 0.962,
              z: 2.355
            }
          },
          {
            "title":"Diseño aerodinámico",
            "text": "La Santa Fe optimiza el consumo de combustible y ofrece una conducción más silenciosa y suave gracias a su aerodinámica refinada.",
            "image": require("./../assets/SANTAFE/EXTERIOR/santafe-hibrida-asistente-seguimiento.webp"),
            "position": {
              x: 0.0,
              y: 1.475,
              z: 0.868
            }
          },
          {
            "title":"Tracción total electrónica (HTRAC AWD)",
            "text": "El sistema de tracción integral mejora la estabilidad y seguridad en diversas condiciones de terreno y clima, proporcionando confianza al conducir (versión Limited).",
            "image": require("./../assets/SANTAFE/EXTERIOR/santafe-hibrida-htrack.webp"),
            "position": {
              x: 0.994,
              y: 0.399,
              z: 1.494
            }
          },
          {
            "title":"Tracción total electrónica (HTRAC AWD)",
            "text": "El sistema de tracción integral mejora la estabilidad y seguridad en diversas condiciones de terreno y clima, proporcionando confianza al conducir (versión Limited).",
            "image": require("./../assets/SANTAFE/EXTERIOR/santafe-hibrida-htrack.webp"),
            "position": {
              x: -0.994,
              y: 0.399,
              z: 1.494
            }
          },
          {
            "title":"Diseño frontal inconfundible",
            "text": "Las luces LED y los faros en forma de H crean una imagen distintiva y optimizan el rendimiento en la oscuridad.",
            "image": require("./../assets/SANTAFE/EXTERIOR/santafe-hibrida-faros-delanteros.webp"),
            "position": {
              x: 0.709,
              y: 0.938,
              z: 2.21
            }
          },
          {
            "title":"Luces traseras combinadas",
            "text": "El diseño sofisticado en forma de H se refleja también en las luces LED traseras.",
            "image": require("./../assets/SANTAFE/EXTERIOR/santafe-hibrida-disenio-trasero.webp"),
            "position": {
              x: 0.619,
              y: 0.805,
              z: -2.409
            }
          },
          {
            "title":"Estilo robusto y elegante",
            "text": "Un diseño audaz con líneas que armonizan con una carrocería robusta, realzada por rines de lujo y guardabarros fuertes.",
            "image": require("./../assets/SANTAFE/EXTERIOR/santafe-hibrida-disenio-trasero2.webp"),
            "position": {
              x: 0.993,
              y: 0.836,
              z: -0.793
            }
          },
          {
            "title":"Apertura y cierre eléctrico del baúl",
            "text": "La puerta trasera se abre y cierra con un botón o llave inteligente, y puedes ajustar la altura de apertura desde la pantalla del vehículo.",
            "image": require("./../assets/SANTAFE/EXTERIOR/santafe-hibrida-baul.webp"),
            "position": {
              x: 0.0,
              y: 1.344,
              z: -2.455
            }
          },
          {
            "title":"Más imponente que nunca",
            "text": "Con un nuevo diseño, la Santa Fe destaca por su tamaño, líneas audaces y carrocería perfectamente modelada.",
            "image": "",
            "position": {
              x: 0.8,
              y: 1.344,
              z: -1.694
            }
          },
          {
            "title":"Rines de aleación de 20 pulgadas",
            "text": "Con rines bitono de 20”, la Santa Fe luce un diseño exclusivo que resalta junto a sus guardabarros.",
            "image": require("./../assets/SANTAFE/EXTERIOR/santafe-hibrida-rines.webp"),
            "position": {
              x: 1.014,
              y: 0.401,
              z: -1.316
            }
          },
          {
            "title":"Rines de aleación de 20 pulgadas",
            "text": "Con rines bitono de 20”, la Santa Fe luce un diseño exclusivo que resalta junto a sus guardabarros.",
            "image": require("./../assets/SANTAFE/EXTERIOR/santafe-hibrida-rines.webp"),
            "position": {
              x: -1.014,
              y: 0.401,
              z: -1.316
            }
          },
          {
            "title":"Portaequipajes tipo puente",
            "text": "Rieles robustos en el techo ofrecen funcionalidad y estabilidad para tus aventuras.",
            "image": require("./../assets/SANTAFE/EXTERIOR/santafe-hibrida-techo.webp"),
            "position": {
              x: 0.572,
              y: 1.828,
              z: -0.643
            }
          },
          {
            "title":"Aletas de aire automáticas",
            "text": "Las aletas de aire se ajustan automáticamente para mejorar la refrigeración aerodinámica según las condiciones de manejo.",
            "image": require("./../assets/SANTAFE/EXTERIOR/santafe-hibrida-paleta-frontal.webp"),
            "position": {
              x: 0.0,
              y: 0.745,
              z: 2.422
            }
          },
          {
            "title":"Sensores de parqueo",
            "text": "Los sensores advierten sobre objetos cercanos mientras estacionas o sales del lugar.",
            "image": require("./../assets/SANTAFE/EXTERIOR/santafe-hibrida-sensores-parqueo.webp"),
            "position": {
              x: 0.0,
              y: 0.492,
              z: -2.460
            }
          }
          ,
          {
            "title":"Asistente de luces altas",
            "text": "Ajusta automáticamente las luces altas según las condiciones del camino.",
            "image": require("./../assets/SANTAFE/EXTERIOR/santafe-hibrida-asistente-luz.webp"),
            "position": {
              x: -0.68,
              y: 0.890,
              z: 2.25
            }
          }
          ,
          {
            "title":"Asistente de colisión en punto ciego",
            "text": "Asiste en el frenado si detecta un riesgo de colisión al cambiar de carril o al salir de un estacionamiento paralelo.",
            "image": require("./../assets/SANTAFE/EXTERIOR/santafe-hibrida-asistente-colision-trasera.webp"),
            "position": {
              x: -0.632,
              y: 0.584,
              z: -2.417
            }
          }
          ,
          {
            "title":"Asistente de mantenimiento de carril",
            "text": "Advierte cuando el vehículo sale del carril sin señalizar y ajusta la dirección automáticamente para mantener el curso.",
            "image": require("./../assets/SANTAFE/EXTERIOR/santafe-hibrida-lka.webp"),
            "position": {
              x: 0.0,
              y: 0.353,
              z: 2.449
            }
          }
          ,
          {
            "title":"Asistente de control crucero inteligente",
            "text": "Mantiene la distancia con el vehículo adelante y ajusta la velocidad según las condiciones del tráfico.",
            "image": require("./../assets/SANTAFE/EXTERIOR/santafe-hibrida-scc.webp"),
            "position": {
              x: 0.434,
              y: 0.353,
              z: 2.449
            }
          }
          ,
          {
            "title":"Asistente de colisiones al retroceder",
            "text": "Te advierte y frena automáticamente en caso de riesgo de colisión al retroceder.",
            "image": require("./../assets/SANTAFE/EXTERIOR/santafe-hibrida-asistente-colision-trasera.webp"),
            "position": {
              x: 0.000,
              y: 1.054,
              z: -2.490
            }
          }
          ,
          {
            "title":"Asistente de giro en intersecciones",
            "text": "Detecta el riesgo de colisión al girar en intersecciones y frena automáticamente para evitar accidentes.",
            "image": require("./../assets/SANTAFE/EXTERIOR/santafe-hibrida-asistente-giro.webp"),
            "position": {
              x: 0.992,
              y: 0.823,
              z: 1.484
            }
          }
          ,
          {
            "title":"Asistente de giro en intersecciones",
            "text": "Detecta el riesgo de colisión al girar en intersecciones y frena automáticamente para evitar accidentes.",
            "image": require("./../assets/SANTAFE/EXTERIOR/santafe-hibrida-asistente-giro.webp"),
            "position": {
              x: -0.992,
              y: 0.823,
              z: 1.484
            }
          }
        ],
        "interior": [
          {
            "title":"Sistema de regeneración inteligente",
            "text": "Mejora la eficiencia ajustando automáticamente el frenado regenerativo según el tráfico y la información del mapa, mientras el vehículo está en modo deslizamiento. En los modos ECO o SMART, el frenado se ajusta en 3 niveles mediante las palancas de cambio.",
            "image": require("./../assets/SANTAFE/INTERIOR/santafe-hibrida-sistema-regeneracion.webp"),
            "position": {
              x: 0.562,
              y: 1.113,
              z: 0.577
            }
          },
          {
            "title":"Pantalla curva panorámica",
            "text": "Dos pantallas de 12,3'' unidas para ofrecer conectividad total y un diseño que inspira comodidad.",
            "image": require("./../assets/SANTAFE/INTERIOR/santafe-hibrida-camara-360.webp"),
            "position": {
              x: 0.396,
              y: 1.140,
              z: 0.830
            }
          },{
            "title":"Sonido BOSE",
            "text": "El sistema BOSE premium de 12 altavoces proporciona un sonido envolvente de alta calidad (versión Limited).",
            "image": require("./../assets/SANTAFE/INTERIOR/santafe-hibrida-sonido-bose.webp"),
            "position": {
              x: -0.681,
              y: 1.227,
              z: 0.729
            }
          },{
            "title":"Aire acondicionado automático",
            "text": "Controla la temperatura y el flujo de aire en la Santa Fe con su pantalla táctil intuitiva.",
            "image": require("./../assets/SANTAFE/INTERIOR/santafe-hibrida-aire-acondicionado.webp"),
            "position": {
              x: 0.0,
              y: 0.932,
              z: 0.672
            }
          },{
            "title":"Tercera fila ajustable y con ISOFIX",
            "text": "Con capacidad para 7 pasajeros, esta SUV ofrece comodidad y seguridad para todos, perfecta para familias grandes o grupos.",
            "image": require("./../assets/SANTAFE/INTERIOR/santafe-hibrida-tercera-fila.webp"),
            "position": {
              x: 0.000,
              y: 1.142,
              z: -1.498
            }
          },{
            "title":"Smartshift electrónicamente inteligente",
            "text": "La palanca de cambios ergonómica optimiza la experiencia de conducción, facilitando tu manejo.",
            "image": require("./../assets/SANTAFE/INTERIOR/santafe-hibrida-smart-shift.webp"),
            "position": {
              x: 0.445,
              y: 1.113,
              z: 0.595
            }
          },{
            "title":"Cargador inalámbrico",
            "text": "Plataforma de carga dual con ventilación incorporada para evitar el sobrecalentamiento mientras cargas dos dispositivos a la vez.",
            "image": require("./../assets/SANTAFE/INTERIOR/santafe-hibrida-carga-inalambrica.webp"),
            "position": {
              x: 0.0,
              y: 0.871,
              z: 0.538
            }
          },{
            "title":"Cojinería de cuero",
            "text": "Disfruta del confort y la exclusividad que ofrecen los acabados de cuero en cada viaje.",
            "image": require("./../assets/SANTAFE/INTERIOR/santafe-hibrida-cojineria-cuero.webp"),
            "position": {
              x: -0.461,
              y: 1.218,
              z: 0.023
            }
          },{
            "title":"Cámara de reversa con guías dinámicas",
            "text": "El monitor trasero te ayuda a estacionar con precisión, mostrando guías dinámicas para mayor seguridad.",
            "image": "",
            "position": {
              x: -0.083,
              y: 1.104,
              z: 0.746
            }
          },{
            "title":"Cámara 360°",
            "text": "Proporciona una vista en 3D de 360° para facilitar la conducción y el estacionamiento (versión Limited).",
            "image": require("./../assets/SANTAFE/INTERIOR/santafe-hibrida-camara-360.webp"),
            "position": {
              x: 0.052,
              y: 1.090,
              z: 0.780
            }
          },{
            "title":"Monitor de punto ciego",
            "text": "Muestra la vista del punto ciego al activar las direccionales en el panel de instrumentos (versión Limited).",
            "image": require("./../assets/SANTAFE/INTERIOR/santafe-hibrida-punto-ciego.webp"),
            "position": {
              x: 0.186,
              y: 1.091,
              z: 0.822
            }
          },
          
        ]
      },
    }
  }
}